import { TestId } from "../testIdType"

export const testId: TestId = {
    notificationPayload: "notification-payload",
    btnClose: "btn-close"
}
